<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <div class="leftSection">
            <div class="header-title wrapper-content__main font-weight__bold">
              Văn bản chờ tiếp nhận
            </div>
          </div>
        </template>
      </headerTemplate>
    </template>
    <template #view>
      <div class="view">
        <listTemplate
          :classCustom="'wrapper-content__main margin-right-10'"
          style="height: calc(100% - 60px)"
        >
          <template #subHeader>
            <subHeader>
              <template #content>
                <div class="leftSection">
                  <el-button
                    v-if="checkCurrentActive()"
                    size="medium"
                    type="success"
                    class="createNew"
                    @click="openCreateDocDialog"
                  >
                    <div class="flex-row flex__center">
                      <i class="fas fa-file-plus"></i>
                      <span>THÊM MỚI</span>
                    </div>
                  </el-button>
                </div>
                <searchTemplate
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #quickFilter>
                    <div
                      class="
                        flex-row
                        flex-left__top
                        margin-right-10
                        custom-label__input
                      "
                      style="margin-top: 0px"
                    >
                      <span
                        style="margin-top: 0px"
                        class="label-input width__auto"
                        >VB trong hệ thống
                      </span>
                      <el-checkbox
                        class="
                          style-fullWidth
                          input-border__bottom input-border__radius__0
                          bg__transparent
                        "
                        v-model="inPublisher"
                        @change="filterByTypePublisher"
                      ></el-checkbox>
                    </div>
                    <div
                      class="
                        flex-row
                        flex-left__top
                        margin-right-10
                        custom-label__input
                      "
                      style="margin-top: 0px"
                    >
                      <span
                        style="margin-top: 0px"
                        class="label-input width__auto"
                        >VB ngoài hệ thống
                      </span>
                      <el-checkbox
                        class="
                          style-fullWidth
                          input-border__bottom input-border__radius__0
                          bg__transparent
                        "
                        v-model="outPublisher"
                        @change="filterByTypePublisher"
                      ></el-checkbox>
                    </div>
                    <div
                      class="
                        flex-row
                        flex-left__top
                        margin-right-10
                        custom-label__input
                        fix-width__large
                      "
                    >
                      <span class="label-input width__auto">Ngày đến</span>
                      <el-date-picker
                        v-model="incomingDateRange"
                        type="daterange"
                        format="dd/MM/yyyy"
                        class="
                          style-fullWidth
                          input-border__bottom input-border__radius__0
                          bg__transparent
                        "
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="right"
                        :clearable="false"
                        @change="filterByIncomingDateRange"
                      ></el-date-picker>
                    </div>
                  </template>
                  <template #advance>
                    <chotiepnhan-advance-search-dialog
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                    />
                  </template>
                </searchTemplate>
              </template>
            </subHeader>
          </template>

          <template #body>
            <div class="list index-doc-in">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <!-- <div class="leftSection flex-row flex__left"> -->
                <div class="theTitle flex-row flex__center theTitle__lv6">
                  <span class="stt flex-row flex__center">STT</span>
                </div>
                <div
                  class="theTitle theTitle__lv5 flex-row flex__left clickable"
                  @click="doSort('docCode')"
                >
                  Số ký hiệu
                  <sort-caret :order="order" :sort="sort" :field="'docCode'" />
                </div>
                <div
                  class="theTitle theTitle__lv1 flex-row flex__left clickable"
                  @click="doSort('quote')"
                >
                  Trích yếu
                  <sort-caret :order="order" :sort="sort" :field="'quote'" />
                </div>
                <!-- </div>
                <div class="rightSection flex-row flex__right"> -->
                <div
                  class="theTitle theTitle__lv2 flex-row flex__left clickable"
                  @click="doSort('forwardDeptName')"
                >
                  Nơi gửi
                  <sort-caret
                    :order="order"
                    :sort="sort"
                    :field="'forwardDeptName'"
                  />
                </div>
                <div
                  class="theTitle theTitle__lv2 flex-row flex__left clickable"
                  @click="doSort('publisherName')"
                >
                  Đơn vị phát hành
                  <sort-caret
                    :order="order"
                    :sort="sort"
                    :field="'publisherName'"
                  />
                </div>
                <div
                  class="theTitle theTitle__lv3 flex-row flex__left clickable"
                  @click="doSort('docDate')"
                >
                  Ngày văn bản
                  <sort-caret :order="order" :sort="sort" :field="'docDate'" />
                </div>
                <div
                  class="theTitle theTitle__lv3 flex-row flex__left clickable"
                  @click="doSort('incomingDate')"
                >
                  Ngày đến
                  <sort-caret
                    :order="order"
                    :sort="sort"
                    :field="'incomingDate'"
                  />
                </div>
                <div
                  class="theTitle theTitle__lv5 flex-row flex__left clickable"
                  @click="doSort('status')"
                >
                  Trạng thái
                  <sort-caret :order="order" :sort="sort" :field="'status'" />
                </div>
                <!-- </div> -->
              </div>
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in incomingDocs"
                    v-bind:key="$itemIndex"
                    class="item flex-row flex__between"
                    @click="viewDetail(item)"
                  >
                    <!-- <div class="leftSection flex-row flex__left"> -->
                    <div class="theTitle__lv6">
                      <div class="flex-row flex__center">
                        <div class="section-check flex-row flex__center">
                          {{ $itemIndex + 1 }}
                        </div>
                        <i class="fas fa-file color__silver"></i>
                      </div>
                    </div>
                    <div class="theTitle__lv5">
                      <div class="flex-row flex__left">
                          {{ item.docCode }}
                      </div>
                    </div>
                    <div class="theTitle__lv1">
                      <div class="title-docs flex-col flex__left">
                        <a
                          class="custom-link-detail"
                          :href="convertLinkToDetail(item)"
                          @click="stopProcess"
                        >
                          <div
                            class="tt_1 clickable"
                            v-bind:class="textBold(item)"
                          >
                            {{ item.quote }}
                          </div>
                        </a>
                        <div class="tt_2 flex-row flex__left">
                          <span v-if="item.docCode"
                            >{{ item.docCode }}&nbsp;&nbsp;</span
                          >
                          <el-tag
                            v-if="item.docTypeName"
                            size="mini"
                            :class="['priority', 'lv3']"
                            >{{ item.docTypeName }}
                          </el-tag>
                          <el-tag
                            v-if="isShowPriority(item.priorityId)"
                            size="mini"
                            :class="[
                              'priority',
                              getPiorityClass(item.priorityId),
                            ]"
                          >
                            <i class="fas fa-bolt"></i>
                            <span>{{ item.priorityName }}</span>
                          </el-tag>
                        </div>
                      </div>
                    </div>
                    <!-- </div>
                    <div class="rightSection flex-row flex__right"> -->
                    <div
                      class="theTitle__lv2 flex-row flex__left font-size__small"
                    >
                      <div class="flex-row flex__left txt-left">
                        {{ item.forwardDeptName || item.publisherName || "-" }}
                      </div>
                    </div>
                    <div
                      class="theTitle__lv2 flex-row flex__left font-size__small"
                    >
                      <div class="flex-row flex__left txt-left">
                        {{
                          item.publisherName || item.outsidePublisherName || "-"
                        }}
                      </div>
                    </div>
                    <div
                      class="theTitle__lv3 flex-row flex__left font-size__small"
                    >
                      <div class="flex-row flex__left txt-right">
                        <i
                          class="cellIcon color__silver fas fa-file-import"
                        ></i>
                        {{
                          item.docDate
                            | dateFormatter({
                              nullValue: "-",
                              dateFormat: "DD/MM/YYYY",
                            })
                        }}
                      </div>
                    </div>
                    <div
                      class="theTitle__lv3 flex-row flex__left font-size__small"
                    >
                      <div class="flex-row flex__left txt-left">
                        <i class="cellIcon color__silver fas fa-clock"></i>
                        {{
                          item.incomingDate | dateFormatter({ nullValue: "-" })
                        }}
                      </div>
                    </div>
                    <div
                      class="theTitle__lv5 flex-row flex__left font-size__small"
                      style="padding-right: 10px"
                    >
                      <div class="flex-row flex__left txt-left">
                        <div
                          class="
                            status-doc
                            flex-row flex__left
                            font-size__medium
                          "
                        >
                          <span>
                            {{ getStatus(item) }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="theQuickAction flex-row flex__left"
                      v-if="isEnableDelete(item)"
                    >
                      <el-tooltip
                        content="Xóa"
                        placement="top"
                        v-if="isEnableDelete(item)"
                      >
                        <i
                          class="
                            action-icon
                            bgAmbient__red
                            clickable
                            fas
                            fa-trash
                          "
                          @click.stop="delete_(item)"
                        ></i>
                      </el-tooltip>
                    </div>
                    <!-- </div> -->
                  </div>

                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không có dữ liệu</div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </listTemplate>
      </div>

      <create-doc-in-dialog
        :isOpen="isOpenDialogCreate"
        :id="selectedDocId"
        v-if="isEnableDialogCreate"
        @dialogClosed="isEnableDialogCreate = false"
        @closeDialog="closeDialog"
        @success="createDocSuccess"
        @deleteSuccess="doWithDocSuccess"
        @rejectSuccess="doWithDocSuccess"
        @cxlSuccess="cxlSuccess"
      />
    </template>
  </listTemplate>
</template>
<script>
import InfiniteLoading from "vue-infinite-loading";
import incomingDocService from "../../services/incomingDocService";
import dateFormatter from "../../filters/dateFormatter";
import constants from "../../constants";
import utils from "../../services/utils";
import listTemplate from "../common/list";
import { EventBus } from "../../event-bus.js";
import ChotiepnhanAdvanceSearchDialog from "./components/chotiepnhan-advance-search-dialog";
import vbDenVTMixin from "./vbDenVTMixin";
import CreateDocInDialog from "./components/CreateDialog";

export default {
  mixins: [vbDenVTMixin],

  components: {
    CreateDocInDialog,
    ChotiepnhanAdvanceSearchDialog,
    InfiniteLoading,
    listTemplate,
    headerTemplate: () => import("../../components/header/main-header.vue"),
    searchTemplate: () => import("../common/search.vue"),
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
    subHeader: () => import("../../components/main/sub-header.vue"),
    SortCaret: () => import("../doc-out/SortCaret"),
  },

  filters: { dateFormatter },

  data() {
    return {
      dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),

      isOpenAdvanceSearchDialog: false,
      isEnableAdvanceSearchDialog: false,
      isOpenDialogCreate: false,
      isEnableDialogCreate: false,
      perfectScrollbarSetting: { maxScrollbarLength: 350 },

      incomingDocs: [],
      selectedDocId: null,

      page: 0,
      size: 10,
      sort: null,
      order: null,
      keyword: null,
      typePublisher: null,
      inPublisher: false,
      outPublisher: false,

      createDocFlag: 0, //cờ để phân biệt là mở popup từ dialog create ?!
    };
  },

  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
    currentRoute() {
      return this.$route.path.split("/")[3];
    },
  },

  watch: {
    isOpenDialogCreate(newValue) {
      if (newValue) {
        this.isEnableDialogCreate = newValue;
      } else {
        if (this.createDocFlag > 0) this.createDocFlag--;
      }
    },

    isOpenAdvanceSearchDialog(newValue) {
      newValue && (this.isEnableAdvanceSearchDialog = newValue);
    },

    isEnableDialogCreate(newValue) {
      if (!newValue) {
        this.selectedDocId = null;
        /**
         * tiếp tục mở dialog để thực hiện nhập liệu tiếp nhận văn bản
         */
        if (this.createDocFlag > 0) {
          console.log(
            "tiếp tục mở dialog để thực hiện nhập liệu tiếp nhận văn bản"
          );
          this.$nextTick(() => (this.isOpenDialogCreate = true));
        }
      }
    },
  },

  created() {
    this.initQuery();
  },

  mounted() {
    EventBus.$on(this.currentRoute, (options) => {
      this.doSearch();
    });
    this.openTiepNhanDialog();
  },

  methods: {
    convertLinkToDetail(item) {
      return `${window.location.origin}/#/app/${this.$store.getters.userDeptRoleId}/vbChoTiepNhan?id=${item.id}`;
    },

    stopProcess(e) {
      e.preventDefault();
    },

    filterByTypePublisher() {
      if (this.inPublisher && !this.outPublisher) {
        this.advanceSearchForm.typePublisher = 1;
      } else if (this.outPublisher && !this.inPublisher) {
        this.advanceSearchForm.typePublisher = 2;
      } else if (this.inPublisher && this.outPublisher) {
        this.advanceSearchForm.typePublisher = null;
      } else {
        this.advanceSearchForm.typePublisher = undefined;
      }
      this.doSearch();
    },

    checkCurrentActive() {
      return (
        this.$store.getters.userDeptRole &&
        this.$store.getters.userDeptRole.status === "active" &&
        this.$store.getters.userDeptRole.deptStatus === "active"
      );
    },

    openCreateDocDialog() {
      this.isOpenDialogCreate = true;
      this.createDocFlag++;
    },

    /**
     * khi click vao notify (trong TH ban hanh van ban) > se redirect toi trang nay va thuc hien mo popup;
     */
    openTiepNhanDialog() {
      let docId = localStorage.getItem(
        constants.STORAGE_KEY.CHO_TIEP_NHAN_DOC_ID
      );
      if (docId) {
        this.isOpenDialogCreate = true;
        this.selectedDocId = docId;
        localStorage.removeItem(constants.STORAGE_KEY.CHO_TIEP_NHAN_DOC_ID);
      }
    },

    textBold(event) {
      if (event.hasOwnProperty("isRead")) {
        if (event.isRead === "seen") return "";
        else return "text-bold";
      } else return "";
    },

    getStatus(item) {
      let checkChuaVaoSo =
        item.isInBook === constants.INCOMING_DOC.DA_VAO_SO
          ? "Đã vào sổ"
          : "Chưa vào sổ";
      let checkStatus =
        item.status === constants.INCOMING_DOC_STATUS.TU_CHOI
          ? " - Từ chối"
          : "";
      return `${checkChuaVaoSo} ${checkStatus}`;
    },

    closeDialog() {
      this.isOpenDialogCreate = false;
    },

    isShowPriority(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) !== -1;
    },

    createDocSuccess() {
      this.createDocFlag++;
      this.doWithDocSuccess();
    },

    cxlSuccess() {
      this.createDocFlag++;
      this.doWithDocSuccess();
    },

    doWithDocSuccess() {
      this.isOpenDialogCreate = false;
      this.doSearch();
    },

    initQuery() {
      if (this.$route.query.id) {
        this.viewDetail({ id: this.$route.query.id });
      }
      this.sort = this.$route.query.sort || "incomingDate";
      this.order = this.$route.query.order || "desc";
      this.advanceSearchForm = {
        typePublisher: parseInt(this.$route.query.typePublisher) || undefined,
        keyword: this.$route.query.keyword || undefined,
        fromDocDate: this.$route.query.fromDocDate
          ? parseInt(this.$route.query.fromDocDate)
          : undefined,
        toDocDate: this.$route.query.toDocDate
          ? parseInt(this.$route.query.toDocDate)
          : undefined,
        fromIncomingDate: this.$route.query.fromIncomingDate
          ? parseInt(this.$route.query.fromIncomingDate)
          : undefined,
        toIncomingDate: this.$route.query.toIncomingDate
          ? parseInt(this.$route.query.toIncomingDate)
          : undefined,
        docCode: this.$route.query.docCode || undefined,
        quote: this.$route.query.quote || undefined,
        fileContent: this.$route.query.fileContent || undefined,
        docTypeId: this.$route.query.docTypeId || undefined,
        bookId: this.$route.query.bookId || undefined,
        publisherId: this.$route.query.publisherId || undefined,
        outsidePublisherName:
          this.$route.query.outsidePublisherName || undefined,
      };
      if (this.advanceSearchForm.typePublisher === 1) {
        this.inPublisher = true;
      } else if (this.advanceSearchForm.typePublisher === 2) {
        this.outPublisher = true;
      } else if (this.$route.query.typePublisher === undefined) {
        this.inPublisher = false;
        this.outPublisher = false;
      } else {
        this.inPublisher = true;
        this.outPublisher = true;
      }
      this.keyword = this.advanceSearchForm.keyword;
      this.initIncomingDateRange();
    },

    buildQuery() {
      return utils.merge(
        { sort: this.sort || "incomingDate", order: this.order || "desc" },
        this.advanceSearchForm
      );
    },

    simpleSearch(keyword) {
      this.keyword = this.advanceSearchForm.keyword = keyword;
      this.advanceSearchForm.docCode = undefined;
      this.advanceSearchForm.quote = undefined;
      this.advanceSearchForm.fileContent = undefined;
      this.advanceSearchForm.docTypeId = undefined;
      this.advanceSearchForm.bookId = undefined;
      this.advanceSearchForm.publisherId = undefined;
      this.advanceSearchForm.outsidePublisherName = undefined;
      this.doSearch();
    },

    advanceSearch(event) {
      let advanceSearchForm = event.advanceSearchForm;
      this.advanceSearchForm.keyword = undefined;
      this.keyword = null;
      this.advanceSearchForm.docCode = advanceSearchForm.docCode || undefined;
      this.advanceSearchForm.quote = advanceSearchForm.quote || undefined;
      this.advanceSearchForm.fileContent =
        advanceSearchForm.fileContent || undefined;
      this.advanceSearchForm.docTypeId =
        advanceSearchForm.docTypeId || undefined;
      this.advanceSearchForm.bookId = advanceSearchForm.bookId || undefined;
      this.advanceSearchForm.publisherId =
        advanceSearchForm.publisherId || undefined;
      this.advanceSearchForm.outsidePublisherName =
        advanceSearchForm.outsidePublisherName || undefined;
      this.advanceSearchForm.toIncomingDate =
        advanceSearchForm.toIncomingDate || undefined;
      this.advanceSearchForm.fromIncomingDate =
        advanceSearchForm.fromIncomingDate || undefined;
      this.advanceSearchForm.fromDocDate =
        advanceSearchForm.fromDocDate || undefined;
      this.advanceSearchForm.toDocDate =
        advanceSearchForm.toDocDate || undefined;
      this.initIncomingDateRange();
      this.doSearch();
    },

    doSort(sort) {
      this.sort = sort;
      this.order =
        sort === this.sort ? (this.order === "asc" ? "desc" : "asc") : "asc";
      this.doSearch();
    },

    doSearch() {
      this.$router.replace({
        name: "vbChoTiepNhan",
        params: this.$route.params,
        query: this.buildQuery(),
      });
      this.incomingDocs = [];
      this.page = 0;
      this.$nextTick(
        () =>
          this.$refs.infiniteLoading &&
          this.$refs.infiniteLoading.stateChanger.reset()
      );
    },

    infiniteHandler($state) {
      this.list().then((items) => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    list() {
      let pageable = {
        page: this.page,
        size: this.size,
        sort: [this.sort, this.order].join(","),
      };

      return incomingDocService
        .listChoTiepNhan2(this.advanceSearchForm, pageable)
        .then((response) => {
          let items = response.data;
          items && this.incomingDocs.push(...items);
          return items;
        });
    },

    viewDetail(item) {
      if (!item.forwardIncomingDocId) {
        item.isRead = "seen";
        this.isOpenDialogCreate = true;
        this.selectedDocId = item.id;
      } else {
        this.$router.push({
          name: "vbChoTiepNhanDetailEditable",
          params: { id: item.id },
        });
      }
    },
    isEnableDelete(item) {
      return (
        item &&
        item.creatorId === this.$store.getters.user.id &&
        this.$store.getters.userDeptRole.roleCode ===
          constants.ROLE.CODE.VAN_THU
      );
    },

    delete_(item) {
      this.$confirm(`Bạn có muốn xóa văn bản "${item.quote}" ?`, "Thông báo", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy bỏ",
        type: "warning",
      }).then(() => {
        incomingDocService
          .deleteForVanThu(item.id)
          .then((respone) => {
            this.$message({
              message: "Xóa thành công",
              type: "success",
              duration: 2000,
            });
            this.doSearch();
          })
          .catch((error) => this.commonHandleRequestError(error));
      });
    },
    getPiorityClass(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) !== -1
        ? "lv1"
        : "lv4";
    },
  },
};
</script>
<style scoped>
/* Start Responsive 19/05 */
.index-doc-in .theTitle__lv1 {
  width: 14% !important;
}
.index-doc-in .theTitle__lv2 {
  width: 12% !important;
}
.index-doc-in .theTitle__lv3 {
  width: 10% !important;
}
.index-doc-in .theTitle__lv5 {
  width: 85px !important;
}
.index-doc-in .theTitle__lv6 {
  width: 75px !important;
}

.index-doc-in .theTitle__lv2 {
  min-width: 110px;
}

@media only screen and (min-width: 1200px) {
  .index-doc-in .theTitle__lv1 {
    width: 20% !important;
  }
  .index-doc-in .theTitle__lv2 {
    width: 16% !important;
  }
  .index-doc-in .theTitle__lv3 {
    width: 12% !important;
  }
  .index-doc-in .theTitle__lv5 {
    width: 105px !important;
  }
  .index-doc-in .theTitle__lv2 {
    min-width: 120px;
  }
}

.list-docs {
  margin-right: 4px;
  padding: 4px 0px;
}
/* End Responsive 19/05 */

.index-doc-in.list .header-title {
  margin: 0px 10px 0px 0px;
}

#searchBox {
  position: relative;
  width: 100%;
}

.advance-search {
  font-size: 17px;
  color: #005eb1;
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
}

.icon-very__small {
  height: 14px;
  padding-top: 4px;
}

.icon-info {
  background-color: #f0c330;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-top: -1px;
  margin-left: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/Index.vue